import { render } from "./Nine.vue?vue&type=template&id=56660dc0&scoped=true"
import script from "./Nine.vue?vue&type=script&lang=js"
export * from "./Nine.vue?vue&type=script&lang=js"

import "./Nine.vue?vue&type=style&index=0&id=56660dc0&scoped=true&lang=less"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56660dc0"]])

export default __exports__